import Http from '@/libs/axios'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    downloadReport({commit}, data) {
      return new Promise((resolve, reject) => {
        Http.post('reports', data, {
          responseType: 'arraybuffer'
        })
          .then(res => resolve(res))
          .catch(err => reject(err))
      });
    },
  }
}
